import { SubstitutedFrom } from '../models/base-holding';
import { Security } from '../models/security';

export class SecurityBuilder {
	private security: Security;

	constructor() {
		this.security = new Security();
	}

	public setCusip(cusip: string): SecurityBuilder {
		this.security.cusip = cusip || '';
		return this;
	}

	public setMorningstarSecId(morningstarSecId: string): SecurityBuilder {
		this.security.morningstarSecId = morningstarSecId;
		return this;
	}

	public setGlobalId(globalId: string): SecurityBuilder {
		this.security.globalId = globalId;
		return this;
	}

	public setAladdinId(aladdinId: string): SecurityBuilder {
		this.security.aladdinId = aladdinId;
		return this;
	}

	public setAladdinPortfolioCode(aladdinPortfolioCode: string): SecurityBuilder {
		this.security.aladdinPortfolioCode = aladdinPortfolioCode;
		return this;
	}

	public setMarket(market: string): SecurityBuilder {
		this.security.market = market;
		return this;
	}

	public setCurrency(currency: string): SecurityBuilder {
		this.security.currency = currency;
		return this;
	}

	public setIsin(isin: string): SecurityBuilder {
		this.security.isin = isin;
		return this;
	}

	public setDescription(description: string): SecurityBuilder {
		this.security.description = description || '';
		return this;
	}

	public setIdentifier(identifier: string): SecurityBuilder {
		this.security.identifier = identifier || '';
		return this;
	}

	public setIdentifierType(identifierType: string): SecurityBuilder {
		this.security.identifierType = identifierType || '';
		return this;
	}

	public setSubType(subType: string): SecurityBuilder {
		this.security.subType = subType || '';
		return this;
	}

	public setTicker(ticker: string): SecurityBuilder {
		this.security.ticker = ticker || '';
		return this;
	}

	public setUniqueId(uniqueId: string): SecurityBuilder {
		this.security.uniqueId = uniqueId;
		return this;
	}

	public setWeight(weight: number): SecurityBuilder {
		this.security.weight = weight || 0;
		return this;
	}

	public setValue(value: number): SecurityBuilder {
		this.security.value = value || 0;
		return this;
	}

	public setAssetClass(assetClass: string): SecurityBuilder {
		this.security.assetClass = assetClass || '';
		return this;
	}

	public setAssetType(assetType: string): SecurityBuilder {
		this.security.assetType = assetType || '';
		return this;
	}

	public setBlackrockFund(blackrockFund: boolean): SecurityBuilder {
		this.security.blackrockFund = blackrockFund;
		return this;
	}

	public setAsOfDate(asOfDate: number): SecurityBuilder {
		if (asOfDate) {
			this.security.asOfDate = new Date(asOfDate);
		}
		return this;
	}

	public setInceptionDate(inceptionDate: Date): SecurityBuilder {
		if (inceptionDate) {
			this.security.inceptionDate = new Date(inceptionDate);
		}
		return this;
	}

	public setAssetClassCategory(assetClassCategory: string): SecurityBuilder {
		this.security.assetClassCategory = assetClassCategory || '';
		return this;
	}

	public setNavMonthlyPerfOneYear(navMonthlyPerfOneYear: number): SecurityBuilder {
		this.security.navMonthlyPerfOneYear = navMonthlyPerfOneYear;
		return this;
	}

	public setNavMonthlyPerfFiveYears(navMonthlyPerfFiveYears: number): SecurityBuilder {
		this.security.navMonthlyPerfFiveYears = navMonthlyPerfFiveYears;
		return this;
	}

	public setNavMonthlyPerfTenYears(navMonthlyPerfTenYears: number): SecurityBuilder {
		this.security.navMonthlyPerfTenYears = navMonthlyPerfTenYears;
		return this;
	}

	public setNavMonthlyPerfYTD(navMonthlyPerfYTD: number): SecurityBuilder {
		this.security.navMonthlyPerfYTD = navMonthlyPerfYTD;
		return this;
	}

	public setNavMonthlySinceInception(navMonthlySinceInception: number): SecurityBuilder {
		this.security.navMonthlySinceInception = navMonthlySinceInception;
		return this;
	}

	public setPortfolioId(portfolioId: number): SecurityBuilder {
		this.security.portfolioId = portfolioId;
		return this;
	}

	public setParentPortfolioId(parentPortfolioId: number): SecurityBuilder {
		this.security.parentPortfolioId = parentPortfolioId;
		return this;
	}

	public setStdNavPerfOneYear(stdNavPerfOneYear: number): SecurityBuilder {
		this.security.stdNavPerfOneYear = stdNavPerfOneYear;
		return this;
	}

	public setStdNavPerfFiveYears(stdNavPerfFiveYears: number): SecurityBuilder {
		this.security.stdNavPerfFiveYears = stdNavPerfFiveYears;
		return this;
	}

	public setStdNavPerfTenYears(stdNavPerfTenYears: number): SecurityBuilder {
		this.security.stdNavPerfTenYears = stdNavPerfTenYears;
		return this;
	}

	public setStdNavPerfSinceInception(stdNavPerfSinceInception: number): SecurityBuilder {
		this.security.stdNavPerfSinceInception = stdNavPerfSinceInception;
		return this;
	}

	public setStdPerfGrossRatio(stdPerfGrossRatio: number): SecurityBuilder {
		this.security.stdPerfGrossRatio = stdPerfGrossRatio;
		return this;
	}

	public setNetExpRatio(netExpRatio: number): SecurityBuilder {
		this.security.netExpRatio = netExpRatio;
		return this;
	}

	public setStdSecYield(stdSecYield: number): SecurityBuilder {
		this.security.stdSecYield = stdSecYield;
		return this;
	}

	public setStdMktPerfOneYear(stdMktPerfOneYear: number): SecurityBuilder {
		this.security.stdMktPerfOneYear = stdMktPerfOneYear;
		return this;
	}

	public setStdMktPerfFiveYears(stdMktPerfFiveYears: number): SecurityBuilder {
		this.security.stdMktPerfFiveYears = stdMktPerfFiveYears;
		return this;
	}

	public setStdMktPerfTenYears(stdMktPerfTenYears: number): SecurityBuilder {
		this.security.stdMktPerfTenYears = stdMktPerfTenYears;
		return this;
	}

	public setStdMktPerfSinceInception(stdMktPerfSinceInception: number): SecurityBuilder {
		this.security.stdMktPerfSinceInception = stdMktPerfSinceInception;
		return this;
	}

	public setMorningstarCategory(value: string): SecurityBuilder {
		this.security.morningstarCategory = value;
		return this;
	}

	public setMorningstarFundId(morningstarFundId: string): SecurityBuilder {
		this.security.morningstarFundId = morningstarFundId;
		return this;
	}

	public setStdPerfAsOfDate(asOfDate: any): SecurityBuilder {
		if (typeof asOfDate === 'number') {
			this.security.stdPerfAsOfDate = this.convertBfmDateToDate(asOfDate);
		}
		if (typeof asOfDate === 'string') {
			this.security.stdPerfAsOfDate = new Date(asOfDate);
		}
		return this;
	}

	public convertBfmDateToDate(asOfDate: number): Date {
		const dateStr = asOfDate.toString();
		return new Date(+dateStr.slice(0, 4), +dateStr.slice(-4, -2) - 1, +dateStr.slice(-2));
	}

	public setUnSubSecYield(unSubSecYield: number): SecurityBuilder {
		this.security.unSubSecYield = unSubSecYield;
		return this;
	}

	public setProspectusExpWaiverType(type: string): SecurityBuilder {
		this.security.prospectusExpWaiverType = type;
		return this;
	}

	public setProspectusExpWaiverDate(date: Date): SecurityBuilder {
		if (date) {
			this.security.prospectusExpWaiverDate = new Date(date);
		}
		return this;
	}

	// Needed for partner securities
	public setOtherIdentifiers(otherIdentifiers: any): SecurityBuilder {
		this.security.otherIdentifiers = otherIdentifiers;
		return this;
	}

	// Needed for partner portfolio alerts
	public setSubstitutedFrom(substitutedFrom: SubstitutedFrom): SecurityBuilder {
		this.security.substitutedFrom = substitutedFrom;
		return this;
	}

	public setPeOrder(peOrder: number): SecurityBuilder {
		this.security.peOrder = peOrder;
		return this;
	}

	public build(): Security {
		return this.security;
	}
}
